export function sfg20DateFormat(dateString, format) {
    return Date.create(dateString, "en-GB").format(format)
}
